// extracted by mini-css-extract-plugin
export default {"pageContent":"PageError_pageContent__KHBkJ","pageIcon":"PageError_pageIcon__qn22d","contentContainer":"PageError_contentContainer__fzw7e"};